<template>
  <div class="products-archive__section-wrapper">
      <div class="uk-grid" uk-grid>
        <div v-for="product in items" class="uk-width-1-2@s uk-width-1-3@tablet uk-width-1-3@m uk-width-1-4@l">
          <product-card :product="product"></product-card>
        </div>
      </div>
  </div>
</template>

<script>
import DataGridResults from 'js/theme-mixins/DataGridResults';

export default {
  mixins: [DataGridResults],
}
</script>



// WEBPACK FOOTER //
// public/themes/frontend/mtg/extensions/rubinred/collections/assets/js/ProductsDataGridResults.vue